export const projectConfig = {
  PORT: process.env.PORT || 3000,
  API_URL: process.env.REACT_APP_API_URL || 'http://localhost:5000/',
  CHECK_TOKEN: process.env.REACT_APP_CHECK_TOKEN || 'api/port',
  MEDIA_PRIVATE_KEY: process.env.REACT_APP_MEDIA_PRIVATE_KEY || '',
  TILE_SERVICE_API_BASE_URL: process.env.REACT_APP_TILE_SERVICE_API_BASE_URL || '',
  TURN_SECRET: process.env.REACT_APP_TURN_SECRET,
  CURRENT_VERSION: process.env.REACT_APP_CURRENT_VERSION || '1.0.0',
};
